import { MapPin, Phone, Clock } from "lucide-react";
import { Reveal } from "./Reveal";
import { ButtonLink } from "./Buttons";
import { site } from "../config/site";

export default function MapSection() {
  return (
    <Reveal>
      <div
        className="grid border border-line bg-surface lg:grid-cols-2"
        data-testid="map-section"
      >
        <div className="relative min-h-[320px] lg:min-h-[440px]">
          <iframe
            title={`Map — ${site.fullName}, ${site.addressShort}`}
            src={site.mapEmbedUrl}
            className="absolute inset-0 h-full w-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
            data-testid="google-map-embed"
          />
        </div>
        <div className="flex flex-col justify-center p-8 md:p-12">
          <p className="eyebrow">Find Us</p>
          <h3 className="mt-4 font-display text-3xl font-medium text-ink">
            {site.addressShort}
          </h3>
          <ul className="mt-7 space-y-5 text-sm leading-relaxed text-soften">
            <li className="flex gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-champagne" />
              <span>
                {site.addressLine1}
                <br />
                {site.addressLine2}
              </span>
            </li>
            <li className="flex gap-3">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-champagne" />
              <a
                href={site.phoneHref}
                className="transition-colors hover:text-champagne-dark"
              >
                {site.phoneDisplay}
              </a>
            </li>
            <li className="flex gap-3">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-champagne" />
              <span>
                {site.hoursDays} · {site.hoursTime}
              </span>
            </li>
          </ul>
          <div className="mt-9 flex flex-wrap gap-3">
            <ButtonLink
              href={site.directionsUrl}
              external
              variant="primary"
              data-testid="get-directions-btn"
            >
              Get Directions
            </ButtonLink>
            <ButtonLink
              href={site.phoneHref}
              variant="outline"
              arrow={false}
              data-testid="map-call-btn"
            >
              Call Salon
            </ButtonLink>
          </div>
        </div>
      </div>
    </Reveal>
  );
}
